/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量23
 * @export
 * @interface Col23
 */
export interface Col23 {
}

/**
 * Check if a given object implements the Col23 interface.
 */
export function instanceOfCol23(value: object): value is Col23 {
    return true;
}

export function Col23FromJSON(json: any): Col23 {
    return Col23FromJSONTyped(json, false);
}

export function Col23FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col23 {
    return json;
}

export function Col23ToJSON(json: any): Col23 {
    return Col23ToJSONTyped(json, false);
}

export function Col23ToJSONTyped(value?: Col23 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

